// shared constants
export type FeeFrequency = 'One-off' | 'Monthly' | 'Quarterly' | 'Semi-Annually' | 'Annually';
export const FEE_FREQUENCIES: Array<FeeFrequency> = [
  'One-off',
  'Monthly',
  'Quarterly',
  'Semi-Annually',
  'Annually',
];
export const LCO_MAX_DAYS_AFTER_COE = 17;
